import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import WorkspaceShell from 'components/WorkspaceShell';
import { materializeTargetUrl, toStickyOsiUrl } from 'actions';
import { useImpersonationEmail } from 'features/impersonation';
function classifyAction(name, action) {
    const candidate = `${name} ${action.target?.restHttps?.urlTemplate || ''}`.toLowerCase();
    if (candidate.includes('agent'))
        return 'agents';
    if (candidate.includes('lead'))
        return 'leads';
    if (candidate.includes('editor') || candidate.includes('landing'))
        return 'editor';
    if (candidate.includes('project'))
        return 'projects';
    return 'dashboard';
}
export default function WorkspaceApp({ user, blocked }) {
    const { t } = useTranslation();
    const impersonateEmail = useImpersonationEmail();
    const quickLinks = useMemo(() => {
        return Object.entries(user.potentialActions)
            .map(([name, action], index) => {
            const baseHref = materializeTargetUrl(action, {}, user.isRowiAdmin ? impersonateEmail : '');
            const href = toStickyOsiUrl(baseHref, user.isSupportSuperuser ? impersonateEmail : '');
            if (!href)
                return null;
            return {
                label: name || `${t('workspace_link_fallback')} ${index + 1}`,
                href,
                description: href.includes('osi') ? t('workspace_link_osi_description') : t('workspace_link_general_description'),
                category: classifyAction(name, action),
            };
        })
            .filter((item) => Boolean(item));
    }, [impersonateEmail, t, user]);
    return _jsx(WorkspaceShell, { user: user, quickLinks: quickLinks, status: "", blocked: blocked });
}
